import { __assign, __rest } from "tslib";
import React from 'react';
import { componentMap } from '../../form-component-map/index';
import { CnFilterPro as CnFilterUI, CnFilterProItem as CnFilterItemUI, CnSearch, } from '@cainiaofe/cn-ui';
var CnFilterPro = function (props) {
    var componentsProps = props.components, _a = props.onecodeProps, onecodeProps = _a === void 0 ? {} : _a, restProps = __rest(props, ["components", "onecodeProps"]);
    var components = __assign(__assign({ CnSearch: CnSearch }, componentMap), componentsProps);
    return (React.createElement(CnFilterUI, __assign({ components: components }, restProps, onecodeProps)));
};
var CnFilterProItem = function (props) {
    var title = props.title;
    return React.createElement(CnFilterItemUI, __assign({ label: title }, props));
};
export { CnFilterPro, CnFilterPro as CnFilter, CnFilterProItem as CnFilterItem, CnFilterProItem, };
